import React from "react";
import { Platform } from "../../docs/loader";
import { useDocsFilters } from "./filtersContext";

export type PlatformNoteProps = {
  platforms: Platform[];
  activePlatforms?: Platform[]; // in future can be provided via context
  children: React.ReactNode;
};

const PlatformNote: React.FC<PlatformNoteProps> = ({
  platforms,
  activePlatforms,
  children,
}) => {
  const { selectedPlatforms } = useDocsFilters();
  const effective = activePlatforms ?? selectedPlatforms;
  const match =
    !effective ||
    effective.length === 0 ||
    platforms.some((p) => effective.includes(p));
  if (!match) return null;
  return (
    <div className="not-prose border-l-4 border-blue-400 bg-blue-50 dark:bg-blue-900/20 text-blue-900 dark:text-blue-100 px-3 py-2 rounded">
      {children}
    </div>
  );
};

export default PlatformNote;
